// utils/dateUtils.js
export const safeParseDate = (dateInput) => {
  // Handle null/undefined
  if (!dateInput) return null;
  
  // If it's already a Date object
  if (dateInput instanceof Date) {
    return isNaN(dateInput.getTime()) ? null : dateInput;
  }
  
  // If it's a Firestore Timestamp
  if (typeof dateInput === 'object' && 'toDate' in dateInput) {
    return dateInput.toDate();
  }
  
  // If it's a number (timestamp)
  if (typeof dateInput === 'number') {
    const date = new Date(dateInput);
    return isNaN(date.getTime()) ? null : date;
  }
  
  // If it's a string
  if (typeof dateInput === 'string') {
    // Try ISO format first
    const isoDate = new Date(dateInput);
    if (!isNaN(isoDate.getTime())) return isoDate;
    
    // Try your custom format: "June 13, 2025 at 11:11:01 AM UTC+1"
    try {
      const [datePart, timePart] = dateInput.split(' at ');
      if (datePart && timePart) {
        const [time, period, timezone] = timePart.split(' ');
        let [hours, minutes, seconds] = time.split(':').map(Number);
        
        // Convert to 24-hour format
        if (period === 'PM' && hours < 12) hours += 12;
        if (period === 'AM' && hours === 12) hours = 0;
        
        const adjustedDate = new Date(datePart);
        adjustedDate.setHours(hours, minutes, seconds);
        return adjustedDate;
      }
    } catch (e) {
      console.warn('Could not parse custom date format:', dateInput);
    }
  }
  
  return null;
};

export const formatArabicDate = (dateInput) => {
  const date = safeParseDate(dateInput);
  if (!date) return 'غير متوفر';
  
  return date.toLocaleString('ar-SA', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true
  });
};